if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        const selector = this.dataset.observeTarget;
        this.target = selector ? document.querySelector(selector) : null;

        if (!this.target) {
          // Nothing to observe (e.g. hero CTA not on page) — stay hidden, fail safe.
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            const targetVisible = entries[0].isIntersecting;
            this.classList.toggle('visible', !targetVisible);
          },
          { threshold: 0 }
        );

        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
